<template>
  <div class="pb-5">
    <nav-bar/>

    <table-element
      :isShowFilter="true"
      :title="$t('Search.title')"
      :fields="fieldsObj"
      :arrOfElement="orders.deliveries"
      :sortSpacing="0"
      :initialSort="'orderNb'"
      class="card mx-2 my-4"
      @updateFilterResults="updateFilterResults"
    >
      <template #header-actions>
        <div v-if="companyUID === 'e58ff614-8449-4c3e-90b8-b42a48c2972b'" class="row">
          <regular-select
            :value="search.archive"
            @change="search.archive = $event"
            :placeholder="$t('Type de recherche')" class="col-12 col-sm-6 col-lg-3 form-group">
            <option value="0">{{$t('Régulières')}}</option>
            <option value="1">{{$t('Archives 0-80')}}</option>
            <option value="2">{{$t('Archives 80-160')}}</option>
          </regular-select>
        </div>
        <div class="row">
          <regular-input
            :value="search.id"
            @input="search.id = $event"
            type="text" :placeholder="$t('Search.order')" class="col-12 col-sm-6 col-lg-3 form-group"/>
          <regular-input
            :value="search.VIN"
            @input="search.VIN = $event"
            type="text" :placeholder="fieldLabel('vin')" class="col-12 col-sm-6 col-lg-3 form-group"/>
          <regular-input
            :value="search.referenceNumber"
            @input="search.referenceNumber = $event"
            type="text" :placeholder="$t('Search.reference')" class="col-12 col-sm-6 col-lg-3 form-group"/>
          <regular-input
            :value="search.source"
            @input="search.source = $event"
            type="text" :placeholder="$t('Search.source')" class="col-12 col-sm-6 col-lg-3 form-group"/>
          <regular-input
            :value="search.pickup"
            @input="search.pickup = $event"
            type="text" :placeholder="$t('Search.pickup')" class="col-12 col-sm-6 col-lg-3 form-group"/>
          <regular-input
            :value="search.delivery"
            @input="search.delivery = $event"
            type="text" :placeholder="$t('Search.delivery')" class="col-12 col-sm-6 col-lg-3 form-group"/>
          <regular-input
            :value="search.billing"
            @input="search.billing = $event"
            type="text" :placeholder="$t('Search.billing')" class="col-12 col-sm-6 col-lg-3 form-group"/>
          <regular-select-status
            :hiddenStatusMap="['processing', 'inspect']"
            @emitStatusSelect="onStatusSelect"
            class="col-12 col-sm-6 col-lg-3 form-group"
          />
          <div class="flex flex-col col-12 col-sm-6 col-lg-3 form-group">
            <label for="dateMin">From Creation Date</label>
            <regular-input
              :value="search.dateReceptionMin"
              @input="search.dateReceptionMin = $event"
              type="date" placeholder="Date min" class="form-group"/>
          </div>
          <div class="flex flex-col col-12 col-sm-6 col-lg-3 form-group">
            <label for="dateMax">To Creation Date</label>
            <regular-input
              :value="search.dateReceptionMax"
              @input="search.dateReceptionMax = $event"
              type="date" placeholder="Date max" class="form-group"/>
          </div>
          <div class="flex flex-col col-12 col-sm-6 col-lg-3 form-group">
            <label for="billingDateMin">From Billing Date</label>
            <regular-input
              :value="search.billingDateMin"
              @input="search.billingDateMin = $event"
              type="date" placeholder="Billing Date" class="form-group"/>
          </div>
          <div class="flex flex-col col-12 col-sm-6 col-lg-3 form-group">
            <label for="billingDateMax">To Billing Date</label>
            <regular-input
              :value="search.billingDateMax"
              @input="search.billingDateMax = $event"
              type="date" placeholder="Billing Date" class="form-group"/>
          </div>
          <regular-datalist-driver
            :value="search.driver"
            @input="search.driver = $event.value"
            :secondList="liste"
            :placeholder="$t('Search.driver')" class="col-12 col-sm-6 col-lg-3 form-group"/>
          <!-- <regular-input
            :value="search.nbSageOne"
            @input="search.nbSageOne = $event"
            type="text" :placeholder="$t('Search.sageone')" class="col-12 col-sm-6 col-lg-3 form-group"/> -->
          <div class="w-100 form-group flex d-flex">
            <div class="col-6">
              <button class="btn btn-kne-orange w-100" @click="clear()">
                {{$t('Search.clear')}}
              </button>
            </div>
            <div class="col-6">
              <button class="btn btn-kne-orange w-100" :disabled="!oneInputFilled" @click="submitSearch()">
                {{$t('Search.submit')}}
              </button>
            </div>
          </div>
        </div>

        <div class="mt-3">
          <custom-excel-search
            class="btn btn-kne-orange pull-right m-1"
            :searchData="orders"
            :name="'order_search_' + getDate(Date.now()) + '.xls'"
            />
        </div>
      </template>

      <template #body-content-desktop="content">
        <!-- List of orders -->
        <tr v-for="(order, index) in content.results"
        class="table-element_hover text-center"
        :key="order.orderNb"
        :class="{
          'drop': order.status === 'Drop',
          'cancel': order.status === 'Cancel',
          'waiting': order.status === 'Attente',
          'pick': order.status === 'Pick',
          'transit': order.status === 'Transit',
          'dispatch': order.status === 'Dispatch',
          'reject': order.status === 'Reject',
          'inspection': order.status === 'Inspection',
          'transfered': order.status === 'Transférée'
          }">
          <td>
            <button type="button" class="btn btn-kne-orange pull-right"  @click="onViewOrder(order.orderNb)">
              {{$t('OrderCurrent.view')}}
            </button>
          </td>
          <td class="nowrap">{{order.orderNb}}
            <hover-tool-tip
            top
            right
            :text="`
            REF: ${order.reference || '-'} <br>
            SOURCE: ${order.source || '-'} <br>
            ${fieldLabelFor(order, 'vin')}: ${order.vin || '-'} <br>
            `"
            clickable
            />
          </td>
          <td class="nowrap">{{getDate(order.date) || '-'}}</td>
          <td class="nowrap">{{shortenString(order.pickup) || '-'}}
            <hover-tool-tip
              v-if="order.pickup.length > 22"
              right
              top
              :text="order.pickup"
              :clickable="true"
            />
            </td>
          <td class="nowrap">{{shortenString(order.delivery) || '-'}}
            <hover-tool-tip
              v-if="order.delivery.length > 22"
              right
              top
              :text="order.delivery"
              :clickable="true"
            />
            </td>
          <td class="nowrap">{{shortenString(order.billing) || '-'}}
            <hover-tool-tip
              v-if="order.billing.length > 22"
              left
              top
              :text="order.billing"
              :clickable="true"
            />
          </td>
          <td class="nowrap">
            {{order.vin}}
            <!-- <span v-if="order.status === 'Dispatch'">{{$t('Search.status.dispatch')}}</span>
            <span v-if="order.status === 'Processing'">{{$t('Search.status.processing')}}</span>
            <span v-if="order.status === 'Pick'">{{$t('Search.status.pick')}}</span>
            <span v-if="order.status === 'Attente'">{{$t('Search.status.waiting')}}</span>
            <span v-if="order.status === 'Transit'">{{$t('Search.status.transit')}}</span>
            <span v-if="order.status === 'Drop'">{{$t('Search.status.drop')}}</span>
            <span v-if="order.status === 'Cancel'">{{$t('Search.status.canceled')}}</span>
            <span v-if="order.status === 'Terminée'">{{$t('Search.status.finished')}}</span>
            <span v-if="order.status === 'Transférée'">{{$t('Search.status.transfered')}}</span>
            <span v-if="order.status === 'Reject'">{{$t('Search.status.rejected')}}</span> -->
          </td>
          <td class="nowrap">{{order.driver || '-'}}</td>
        </tr>
      </template>

      <template #body-content-mobile="content">
        <!-- List of orders -->
        <div v-if="orders.deliveries.length > 0">
          <transition-group name="fade">
            <div class="card my-3 mx-2" v-for="order in content.results" :key="order.orderNb"
              :class="{
                'drop': order.status === 'Drop',
                'cancel': order.status === 'Cancel',
                'waiting': order.status === 'Attente',
                'pick': order.status === 'Pick',
                'transit': order.status === 'Transit',
                'dispatch': order.status === 'Dispatch',
                'reject': order.status === 'Reject'
              }">
              <div class="card-header m-2">
                <h4>{{order.orderNb}}</h4>
                <p><i class="fa fa-calendar" />{{getDate(order.date)}}</p>
                <p v-if="order.status === 'Dispatch'"><i class="fa fa-exclamation" /> {{$t('Search.status.dispatch')}}</p>
                <p v-if="order.status === 'Processing'"><i class="fa fa-exclamation" /> {{$t('Search.status.processing')}}</p>
                <p v-if="order.status === 'Pick'"><i class="fa fa-exclamation" /> {{$t('Search.status.pick')}}</p>
                <p v-if="order.status === 'Attente'"><i class="fa fa-exclamation" /> {{$t('Search.status.waiting')}}</p>
                <p v-if="order.status === 'Transit'"><i class="fa fa-exclamation" /> {{$t('Search.status.transit')}}</p>
                <p v-if="order.status === 'Drop'"><i class="fa fa-exclamation" /> {{$t('Search.status.drop')}}</p>
                <p v-if="order.status === 'Cancel'"><i class="fa fa-exclamation" /> {{$t('Search.status.canceled')}}</p>
                <p v-if="order.status === 'Terminée'"><i class="fa fa-exclamation" /> {{$t('Search.status.finished')}}</p>
                <p v-if="order.status === 'Transférée'"><i class="fa fa-exclamation" /> {{$t('Search.status.transfered')}}</p>
                <p v-if="order.status === 'Reject'"><i class="fa fa-exclamation" /> {{$t('Search.status.rejected')}}</p>
              </div>
              <div class="m-2">
                <p><i class="fa fa-asterisk" /> {{order.reference || '-'}}</p>
                <p><i class="fa fa-info-circle" /> {{order.source || '-'}}</p>
                <p><i class="fa fa-user" /> {{order.driver || '-'}}</p>
                <p><i class="fa fa-car" /> {{order.vin || '-'}}</p>
                <p><i class="fa fa-home" /> {{order.pickup || '-'}}</p>
                <p><i class="fa fa-truck" /> {{order.delivery || '-'}}</p>
                <p><i class="fa fa-credit-card" /> {{order.billing || '-'}}</p>
              </div>
              <div id="action">
                <a :href="'#/OrderInfo?orderId=' + order.orderNb">
                  <input type="button" class="btn btn-kne-orange m-2" :value="$t('OrderCurrent.view')">
                </a>
              </div>
            </div>
          </transition-group>
        </div>
      </template>
    </table-element>

    <loading-render v-if="isLoading" />

  </div>
</template>

<script>
  import regularInput from '../module/basic-components/regularInput.vue'
  import regularCheckbox from '../module/basic-components/regularCheckbox.vue'
  import regularTextarea from '../module/basic-components/regularTextarea.vue'
  import regularSelect from '../module/basic-components/regularSelect.vue'
  import regularDatalistDriver from '../module/basic-components/regularDatalistDriver.vue'
  import hoverToolTip from '../module/basic-components/hoverToolTip.vue'
  import TableElement from '../module/special-components/Table-component/Table-Element.vue'
  import LoadingRender from '../module/special-components/Other-components/LoadingRender.vue'
  import RegularSelectStatus from '../module/basic-components/RegularSelectStatus.vue'
  import CustomExcelSearch from '../module/special-components/Custom-packages/Custom-ExcelSearch.vue'

  // import _ from 'lodash'
  import {db, dbArchives, dbArchives2} from '../../firebase'
  import { dryBoxMixin } from '../../utils/dryBoxLabels'
  import { isRegularOrder } from '@/inventory/inventorySelectors'

  export default {
    name: 'Search',
    mixins: [dryBoxMixin],

    components: {
      regularInput,
      regularCheckbox,
      regularTextarea,
      CustomExcelSearch,
      regularSelect,
      regularDatalistDriver,
      hoverToolTip,
      TableElement,
      LoadingRender,
      RegularSelectStatus
    },

    data () {
      return {
        orders: {
          deliveries: []
        },
        searchArchive: {
          id: ''
        },
        search: {
          id: '',
          VIN: '',
          referenceNumber: '',
          source: '',
          pickup: '',
          delivery: '',
          dateReceptionMin: '',
          dateReceptionMax: '',
          billingDateMin: '',
          billingDateMax: '',
          status: '',
          driver: '',
          billing: '',
          nbSageOne: ''
        },
        customers_fields: {
        'Order': 'order',
        'Ref': 'numRef',
        'Source': 'source',
        [this.fieldLabel('vin', 'VIN')]: 'vin',
        'Date': {
          field: 'creationDate',
          callback: (value) => {
            return this.getDate(value)
          }
        },
        'Pick': 'transmitterName',
        'Drop': 'receiverName',
        'Billing': 'payerName',
        'Status': 'status',
        'Driver': 'driverName',
        'Province pick': 'provincePick',
        'Province drop': 'provinceDrop',
        'Remark': 'comment'
      },
        invalid: false,
        searchHistory: [],
        searchType: '',
        searchText: '',
        historyTypeTag: '',
        fieldsObj: [
          {
            text: '',
            type: '',
            value: ''
          },
          {
            text: this.$t('OrderCurrent.order'),
            type: 'orderNb',
            value: ''
          },
          {
            text: this.$t('OrderCurrent.date'),
            type: 'date',
            value: ''
          },
          {
            text: this.$t('Search.pickup'),
            type: 'pickup',
            value: ''
          },
          {
            text: this.$t('Search.delivery'),
            type: 'delivery',
            value: ''
          },
          {
            text: this.$t('Search.billing'),
            type: 'billing',
            value: ''
          },
          {
            text: this.fieldLabel('vin'),
            type: 'vin',
            value: ''
          },
          {
            text: this.$t('Search.driver'),
            type: 'driver',
            value: ''
          }
        ]
      }
    },

    created () {
      this.isLoading = false
      this.$store.state.isSidebarOpen = false
      this.isScreenSmall = window.innerWidth < 800

      if (this.$store.state.search !== null) {
        const storedSearch = JSON.parse(JSON.stringify(this.$store.state.search))
        this.orders = this.filterRegularDeliveries(storedSearch)
        this.search = JSON.parse(JSON.stringify(this.$store.state.searchFields))
      }

      this.$bindAsArray('liste', db.ref('database/transporter/' + this.companyUID + '/liste'))
    },

    methods: {
      shortenString (text) {
        if (this.checkIsUndefined(text)) return text
        else {
          let subString = text.substring(0, 22)
          if (text.length > 22) subString += '...'
          return `${subString}`
        }
      },

      onStatusSelect (status) {
        this.search.status = status
      },

      updateFilterResults (sortResults) {
        this.filterResults = sortResults
      },

      setLastPage (toPage, fromPage) {
        this.$store.commit('SET_LAST_PAGE', toPage)
      },

      filterRegularDeliveries (payload) {
        if (!payload || !Array.isArray(payload.deliveries)) return payload
        return {
          ...payload,
          deliveries: payload.deliveries.filter(isRegularOrder)
        }
      },

      flattenDeliveries (payload) {
        if (!payload || !Array.isArray(payload.deliveries)) return payload

        const flattened = []

        payload.deliveries.filter(isRegularOrder).forEach(orig => {
          const hs = orig.historySync || {}
          const hsKeys = Object.keys(hs)

          const validHs = hsKeys
            .map(k => ({ key: k, entry: hs[k] }))
            .filter(item => !item.entry || item.entry.isCancelled !== true)

          if (validHs.length === 0) {
            flattened.push({ ...orig })
            return
          }

          validHs.forEach(({ key, entry }) => {
            const copy = { ...orig }

            copy.historyKey = key
            copy.historyEntry = { ...entry }

            if (entry.transmitterName) copy.pickup = entry.transmitterName
            if (entry.receiver) copy.delivery = entry.receiver
            else if (entry.receiverName) copy.delivery = entry.receiverName

            if (entry.chauffeurName) copy.driver = entry.chauffeurName
            else if (entry.chauffeur) copy.driver = entry.chauffeur

            if (entry.pickDate) copy.pickDate = entry.pickDate
            if (entry.dropDate) copy.dropDate = entry.dropDate

            if (typeof entry.price !== 'undefined' && entry.price !== '') copy.price = entry.price

            delete copy.historySync

            flattened.push(copy)
          })
        })

        return { ...payload, deliveries: flattened }
      },

      submitSearch () {
        console.log('Searching')
        var query = ''

        this.isLoading = true
        this.orders.deliveries = []
        if (this.search.id !== '') query = query + 'orderNb=' + this.search.id + '&'
        if (this.search.VIN !== '') query = query + 'vin=' + this.search.VIN + '&'
        if (this.search.referenceNumber !== '') query = query + 'reference=' + this.search.referenceNumber + '&'
        if (this.search.source !== '') query = query + 'source=' + this.search.source + '&'
        if (this.search.pickup !== '') query = query + 'pickup=' + this.search.pickup + '&'
        if (this.search.delivery !== '') query = query + 'delivery=' + this.search.delivery + '&'
        if (this.search.dateReceptionMin !== '') query = query + 'from=' + Date.parse(this.search.dateReceptionMin) + '&'
        if (this.search.dateReceptionMax !== '') query = query + 'to=' + Date.parse(this.search.dateReceptionMax) + '&'
        if (this.search.billingDateMin !== '') query = query + 'billingDateMin=' + Date.parse(this.search.billingDateMin) + '&'
        if (this.search.billingDateMax !== '') query = query + 'billingDateMax=' + Date.parse(this.search.billingDateMax) + '&'
        if (this.search.status !== '') query = query + 'status=' + this.search.status + '&'
        if (this.search.billing !== '') query = query + 'billing=' + this.search.billing + '&'
        if (this.search.driver !== '') query = query + 'driver=' + this.search.driver
        if (this.search.nbSageOne !== '') query = query + 'sageOne=' + this.search.nbSageOne
        if (query.slice(-1) === '&') query = query.slice(0, -1)

        if (this.search.archive === '1' || this.search.archive === '2') {
          window.axios.get('https://archivesapi.keepneye.com/archive' + this.search.archive + '/decode/search/' + this.companyUID + '/' + query).then((response) => {
            const payload = JSON.parse(JSON.stringify(response.data || { deliveries: [] }))
            const results = this.filterRegularDeliveries(payload)
            this.$store.commit('SET_LAST_PAGE', 0)
            this.$store.commit('STORE_SEARCH', results)
            this.$store.commit('STORE_SEARCH_FIELD', this.search)
            this.orders = results
          }).catch((error) => console.log(error))
        } else {
          // window.axios.get('http://localhost:8080/decode/search/' + this.companyUID + '/' + query).then((response) => {
          window.axios.get('https://archivesapi.keepneye.com/search/decode/search/' + this.companyUID + '/' + query).then((response) => {
            const transformed = this.flattenDeliveries(response.data)
            const payload = JSON.parse(JSON.stringify(transformed || { deliveries: [] }))
            const results = this.filterRegularDeliveries(payload)
            this.$store.commit('STORE_SEARCH', results)
            this.$store.commit('STORE_SEARCH_FIELD', this.search)
            this.orders = results
          }).catch((error) => console.log(error))
        }

        this.isLoading = false
        console.log('Search finished')
      },

      onViewOrder (orderId) {
        this.$router.push({name: 'OrderInfo', query: {orderId: orderId, archive: false, archivedOrder: true}})
      },

      submitSearchArchive () {
        if (this.search.archived === '0') {
          dbArchives2.ref('database/transporter/e58ff614-8449-4c3e-90b8-b42a48c2972b/deliveries').child(this.searchArchive.id).once('value').then((snap) => {
            if (snap.val() && isRegularOrder(snap.val())) {
              this.$router.push({name: 'OrderInfo', query: {orderId: this.searchArchive.id, archive: false, archivedOrder: true}})
            } else {
              this.invalid = true
              console.log('Not valid')
            }
          })
        } else {
          dbArchives.ref('database/transporter/e58ff614-8449-4c3e-90b8-b42a48c2972b/deliveries').child(this.searchArchive.id).once('value').then((snap) => {
            if (snap.val() && isRegularOrder(snap.val())) {
              this.$router.push({name: 'OrderInfo', query: {orderId: this.searchArchive.id, archive: true, archivedOrder: true}})
            } else {
              this.invalid = true
              console.log('Not valid')
            }
          })
        }
      },
      getDate: function (timestamp) {
        var date = new Date(timestamp)
        return date.toLocaleDateString() + ' ' + date.toLocaleTimeString()
      },
      clear () {
        for (var attr in this.search) {
          this.search[attr] = ''
          this.orders.deliveries = []
          this.$store.commit('CLEAR_SEARCH')
        }
      },
      onResize: window._.debounce(function () {
        this.isScreenSmall = window.innerWidth < 800
      }, 50)
    },
    beforeDestroy () {
      if (typeof window !== 'undefined') {
        window.removeEventListener('resize', this.onResize, { passive: true })
      }
    },
    computed: {
      oneInputFilled: function () {
        var hasInput = false
        for (var attr in this.search) {
          if (this.search[attr] !== '') hasInput = true
        }
        return hasInput
      },
      companyUID () {
        return this.$store.state.authorization.company
      },
      isAdmin () {
        return this.$store.state.authorization.role === 'Admin'
      }
    },
    mounted () {
      this.onResize()
      window.addEventListener('resize', this.onResize, { passive: true })
      if (this.$store.state.searchLastPage !== 0) this.$refs.paginator.goToPage(this.$store.state.searchLastPage)
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .table thead th{
    border-bottom: 1px solid #eceeef;
    border-top: none;
  }
  #addOrder{
    position: fixed;
    right: 1rem;
    bottom: 1rem;
  }
  #action{
    display: flex;
    justify-content: end;
  }
  .fa-exclamation{
    margin-left: 0.25rem;
  }
</style>
